<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header d-flex">
                <div class="title">{{ 'FILES.EDIT_DATA_FILE' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm btn-back mr-3" routerLink="/files">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                    <button class="btn btn-primary btn-sm mr-3 btn-create btn-download" type="button" (click)="fileField.click()">
                        <input 
                          class="hide"
                          type="file"
                          [multiple]="multiple"
                          #fileField
                          (change)="selectFile($event.target.files)">
                          <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true"
                          [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>Загрузить новый файл
                    </button>
                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onUpdate()" [disabled]="form.invalid">
                        <!-- <i class="bi bi-save"></i>  -->
                        {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row card-body-content" *ngIf="fileData">

                     <!-- Card-img -->
                        <div class="col-4 align-self-center">
                            <div class="img-file-info block-photo">
                                <div class="file-img product-img" *ngIf="(fileData.extension == 'jpg' || fileData.extension == 'png' || fileData.extension == 'jpeg' || fileData.extension == 'png') && fileLink != null">
                                    <img class="product-img_sze" src="{{ fileLink }}">
                                </div>
                                <div class="product-img block-no-photo" *ngIf="(fileData.extension != 'jpg' && fileData.extension != 'png' && fileData.extension != 'jpeg' && fileData.extension != 'png') || fileLink == null">
                                    <img src="/assets/images/icons/no-photo.svg" class="product-img_sze">
                                </div>
                            </div>
                        </div>    


                    <!-- Editable -->
                        <div class="col-8" *ngIf="fileData">

                            <div class="row">

                                <div class="col-6 product-info">
                                    <div class="form-group">
                                        <label for="name" class="label">{{ 'DENOMINATION' | translate }}<svg-icon ngbTooltip="{{ 'Обязательное для заполнения' | translate }}" placement="right" tooltipClass="clue-name" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon></label>
                                        <input type="text" class="form-control" id="name" formControlName="name">
                                    </div>
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.name">
                                            <div class="text-error" *ngIf="validation('name', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="col-6 product-info">
                                    <div class="form-group">
                                        <label class="label" for="category">{{ 'FILES.CATEGORIE' | translate }}</label>
                                        <ng-select
                                        id="category"
                                        class="custom" 
                                        clearAllText="{{ 'CLEAR' | translate }}"
                                        notFoundText="{{ 'NO_DATA' | translate }}" 
                                        bindLabel="name" 
                                        bindValue="id"
                                        [readonly]="!permissionAccess.check('ADD_FILE_TO_CATEGORY')"
                                        formControlName="category_id"
                                        [items]="categories" 
                                        appendTo="body" >
                                        <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                let-index="index">
                                                <input id="item-{{index}}" type="checkbox"
                                                    [checked]="item$.selected" />&nbsp;
                                                <span>{{item.name}}</span>
                                        </ng-template> -->
                                        </ng-select>
                                    </div>
                                </div>
    
                                <div class="col-6 product-info">
                                    <div class="form-group">
                                        <label class="label" for="valid_to"> Годен до</label>
                                        <app-date-picker-custom-view-control [inputValue]="valid_to" [valueDateTo]="valueDate" (changeValue)="eventFnDPVC('valid_to', $event)"></app-date-picker-custom-view-control>
                                    </div>
                                </div>

                                <div class="col-6 product-info">
                                    <div class="form-group">
                                        <label class="label" for="valid_to"> Расширение</label>
                                        <input type="text" class="form-control" id="extension" formControlName="extension" readonly="true">
                                    </div>
                                </div>

                                <!-- <div class="col-3 product-info file">
                                    <div class="form-group">
                                        <button class="btn btn-primary btn-sm" type="button" (click)="fileField.click()">
                                            <input 
                                              class="hide"
                                              type="file"
                                              [multiple]="multiple"
                                              #fileField
                                              (change)="selectFile($event.target.files)">
                                              <i class="bi bi-download"></i> Загрузить новый файл
                                        </button>
                                    </div>
                                </div> -->

                                
                            </div>
 
                        </div>

                    </div>

                </form>    

            </div>
        </div>

    </div>
</div>
